/** Time between each paw landing along the path. */
export const STEP_INTERVAL = 0.52;
/** Each paw fades in and out once — does not share the full crossing duration. */
export const PAW_DURATION = 0.5;
/** Mouse must be still this long before idle paws and spotlight resume. */
export const IDLE_BEFORE_PAWS_MS = 10000;
export const SPOTLIGHT_HIDE_MS = 280;
